import type { Feature } from "@visioni/a3s-features";
import type { CameraApiResponse } from "@src/services/api/cameras-api";

/** Whether this camera's asset is hired for `feature`. The per-camera
 * counterpart to `holdsFeature`; false while the answer is unknown. */
export function cameraHoldsFeature(camera: CameraApiResponse | undefined, feature: Feature): boolean {
  return camera?.features?.includes(feature) ?? false;
}
